import Icon from 'veui/components/Icon'
import { IconMediaAdd } from 'dls-icons-vue'

Icon.register('media-add', IconMediaAdd)
